const sleep = ms => new Promise(r => setTimeout(r, ms));


export {
  sleep,
}